function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.857 0c-2.84 0-5.143 2.239-5.143 5H0l2.223 2.161.04.078L4.57 5H2.857c0-2.15 1.789-3.889 4-3.889 2.212 0 4 1.739 4 3.889 0 2.15-1.788 3.889-4 3.889a4.025 4.025 0 01-2.823-1.145l-.811.79A5.191 5.191 0 006.857 10C9.697 10 12 7.761 12 5S9.697 0 6.857 0zm-.571 2.778v2.778l2.428 1.4.44-.712-2.011-1.16V2.777h-.857z",
  fill: "#A16855"
});

function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 10",
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "b67f2a632ae0f63f4fadb8e6bfadc309.svg";
export { SvgHistory as ReactComponent };